import { CSSProperties } from "styled-components";
import LogoSvg from "ui/assets/images/logo.svg?react";
import LogoPurpleSvg from "ui/assets/images/logo_purple.svg?react";
import { LogoSize } from "./Logo.types";

export const LOGO_HEIGHT: Record<LogoSize, CSSProperties["height"]> = {
    sm: "1.25rem",
    md: "1.8rem",
    lg: "9rem",
};

export const LOGO_WIDTH: Record<LogoSize, CSSProperties["width"]> = {
    sm: "4rem",
    md: "8rem",
    lg: "12rem",
};

export const LogoIcon = LogoSvg;
export const LogoPurpleIcon = LogoPurpleSvg;
